import { Box, Button, CircularProgress, Link, TextField } from "@mui/material";
import { grey } from "@mui/material/colors";
import React, { useState } from "react";
import { post } from "../../../utils/io";

export default function ForgotPassword() {
  const [username, setUserName] = useState("");
  const [isRequesting, setIsRequesting] = useState(false);
  const [isSuccessful, setIsSuccessful] = useState(false);

  const onChangeInput = (e) => {
    const { value } = e.target;
    setUserName(value);
  };

  const onSubmitForm = async () => {
    setIsRequesting(true);
    await post("/users/password_reset", { username });
    setIsSuccessful(true);
    setIsRequesting(false);
  };
  return (
    <>
      {isSuccessful && (
        <Box
          sx={{
            border: `1px solid ${grey[300]}`,
            padding: 20,
            borderRadius: 4,
            maxWidth: 400,
          }}
        >
          <h2>Request Successful</h2>
          <p>Check your email for a link to reset your password.</p>
          <p>
            Back to <Link href="/login">Login</Link> page
          </p>
        </Box>
      )}
      {!isSuccessful && (
        <Box
          sx={{
            border: `1px solid ${grey[300]}`,
            padding: 20,
            borderRadius: 4,
            maxWidth: 400,
          }}
        >
          <h1>Forgot your password?</h1>
          <h4>Enter your username/email.</h4>
          <TextField
            size="small"
            variant="outlined"
            placeholder="Username"
            label="Username"
            onChange={onChangeInput}
            value={username}
            sx={{ marginBottom: "20px !important", width: "100%" }}
          />
          <Button
            onClick={onSubmitForm}
            variant="contained"
            color="primary"
            sx={{ width: "100%" }}
            disabled={!username || isRequesting}
          >
            {isRequesting && (
              <CircularProgress
                size={16}
                sx={{
                  marginRight: 10,
                }}
              />
            )}{" "}
            Submit
          </Button>
          <Box
            sx={{
              textAlign: "center",
              marginTop: 15,
            }}
          >
            <Link href="/login">Go back</Link>
          </Box>
        </Box>
      )}
    </>
  );
}
